<template>
  <iframe
    :id="id"
    :src="src"
    class="app-indoorviewer__iframe"
    :class="{ 'app-indoorviewer__iframe__split': splitIndoorViewer }"
  />
</template>

<script>
export default {
  name: 'IndoorviewFrame',
  props: {
    id: {
      type: String,
      required: true
    },
    src: {
      validator: (prop) => typeof prop === 'string' || prop == null,
      required: true
    },
    splitIndoorViewer: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variables.scss';

.app-indoorviewer__iframe {
  background-color: #111111;
  border: none;
  height: 100%;
  margin: 0;
  width: 100%;

  &__split {
    width: calc(50% - 2px);
  }
}
</style>
